<script setup lang="ts">
import { ref, onMounted, computed } from 'vue'
import { useNotificationStore } from '@/stores/notificationStore'

// eslint-disable-next-line no-undef
const emit = defineEmits(["app-sidebar-toggled"])

// Store de notifications
const notificationStore = useNotificationStore()

// Compteur de messages non lus
const unreadCount = computed(() => notificationStore.unreadMessagesCount)

// Initialisation
onMounted(async () => {
  // Récupérer le compteur initial
  await notificationStore.fetchUnreadCount()

  // Note: Les listeners Socket.IO sont maintenant gérés globalement
  // via socketListenerService.ts, initialisé dans le router
  // Cela permet de recevoir les notifications sur TOUTES les pages

  // Rafraîchir périodiquement (toutes les 60 secondes en fallback)
  setInterval(() => {
    notificationStore.fetchUnreadCount()
  }, 60000)
})

const activeMenu = ref('');
const appMenus: any = [
  {
    icon: '/icons/icon-menu-dashboard.svg',
    url: '/app/dashboard',
    title: 'Dashboard',
    id: 'menu-dashboard',
    badgeIcon: 'my-badge br2 dot bg-color-notif',
  },
  {
    icon: '/icons/icon-menu-collectivite.svg',
    title: 'Collectivités',
    badgeIcon: 'my-badge br2 dot bg-color-notif',
    id: 'menu-collectivites',
    children: [
      { url: '/app/collectivites/dashboard', title: 'Dashboard', badgeIcon: 'my-badge br3 dot bg-color-warning' },
      { url: '/app/collectivites/list', id: 'menu-collectivites-list', title: 'Gestion des collectivités', badgeIcon: 'my-badge br3 dot bg-color-danger' },
      { url: '/app/users/list', title: 'Gestion des membres' },
      { url: '/app/collectivites/onboarding', id: 'menu-collectivites-onboarding', title: 'Onboarding', badgeIcon: 'my-badge br3 dot bg-color-danger' },
    ]
  },
  {
    icon: '/icons/icon-menu-carte.svg',
    //url: '/app/components',
    title: 'Carte Coop Finance',
    badgeIcon: 'my-badge br2 dot bg-color-notif',
    children: [
      { url: '/app/cartes/form', title: 'Importation de cartes', badgeIcon: 'my-badge br3 dot bg-color-danger' },
      { url: '/app/cartes/list', title: 'Suivi des cartes' },
    ]
  },
  {
    icon: '/icons/icon-menu-finance.svg',
    //url: '/app/components',
    title: 'Finance',
    badgeIcon: 'my-badge br2 dot bg-color-notif',
    children: [
      { url: '#', title: 'Dashboard', badgeIcon: 'my-badge br3 dot bg-color-warning' },
      { url: '/app/finance/assets', title: 'Assets', badgeIcon: 'my-badge br3 dot bg-color-danger' },
      { url: '/app/finance/prelevements', title: 'Prélèvements' },
      { url: '/app/finance/decaissements', title: 'Décaissements', badgeIcon: 'my-badge br3 dot bg-color-danger' },
      { url: '/app/finance/transactions', title: 'Transactions' },
      { url: '#', title: 'Rapports financiers' },
    ]
  },
  {
    icon: '/icons/icon-menu-market.svg',
    //url: '/app/components',
    title: 'Market',
    badgeIcon: 'my-badge br2 dot bg-color-notif',
    children: [
      { url: '#', title: 'Dashboard', badgeIcon: 'my-badge br3 dot bg-color-warning' },
      { url: '#', title: 'Souscriptions', badgeIcon: 'my-badge br3 dot bg-color-danger' },
      { url: '/app/market/market-commandes', title: 'Commandes', badgeIcon: 'my-badge br3 dot bg-color-danger' },
      { url: '/app/market/market-categories/list', title: 'Catégories produits' },
      { url: '/app/market/market-produits/list', title: 'Gestion des produits' },
      { url: '/app/market/market-attributs/list', title: 'Gestion des attributs' },
      { url: '/app/market/market-produits-stocks/list', title: 'Gestion du stock' },
      { url: '#', title: 'Gestion des marchands' },
      { url: '/app/market/market-fournisseurs/list', title: 'Gestion des fournisseurs' },
      { url: '#', title: 'Offres promotionnelles' },
      { url: '#', title: 'Livraison et réception de bien' },
      { url: '#', title: 'Service après-vente' },
      { url: '/app/market/market-settings', title: 'Paramètres marketplace' },
    ]
  },
  {
    icon: '/icons/icon-menu-aide.svg',
    //url: '/app/components',
    title: 'Aide et assistance',
    id: 'menu-aide-assistance',
    badgeIcon: 'my-badge br2 dot bg-color-notif',
    showUnreadBadge: true, // Afficher le badge de messages non lus
    children: [
      { url: '#', title: 'Dashboard', badgeIcon: 'my-badge br3 dot bg-color-warning' },
      { url: '/app/service-client', id: 'menu-service-client', title: 'Service client', showUnreadBadge: true },
      { url: '/app/tutorials/list', id: 'menu-tutorials-list', title: 'Tutoriels' },
      { url: '/app/faq/list', id: 'menu-faq-list', title: 'Faq' },
      { url: '/app/categories-aides/list', id: 'menu-categories-aides-list', title: 'Catégories Aides' },
    ]
  },
  {
    icon: '/icons/icon-menu-marketing.svg',
    //url: '/app/components',
    title: 'Marketing digital',
    badgeIcon: 'my-badge br2 dot bg-color-notif',
    children: [
      { url: '#', title: 'Dashboard', badgeIcon: 'my-badge br3 dot bg-color-warning' },
      { url: '#', title: 'Edition des campagnes', badgeIcon: 'my-badge br3 dot bg-color-danger' },
      { url: '#', title: 'Analyse statistique' },
    ]
  },
  {
    icon: '/icons/icon-menu-api.svg',
    //url: '/app/components',
    title: 'API',
    badgeIcon: 'my-badge br2 dot bg-color-notif',
    children: [
      { url: '#', title: 'API collectivités', badgeIcon: 'my-badge br3 dot bg-color-warning' },
      { url: '#', title: 'API Orange Bank', badgeIcon: 'my-badge br3 dot bg-color-danger' },
    ]
  },
  {
    icon: '/icons/icon-menu-general.svg',
    //url: '/app/components',
    title: 'Général',
    badgeIcon: 'my-badge br2 dot bg-color-notif',
    children: [
      { url: '#', title: 'Témoignages', badgeIcon: 'my-badge br3 dot bg-color-warning' },
      { url: '#', title: 'Partenaires', badgeIcon: 'my-badge br3 dot bg-color-danger' },
    ]
  },
  {
    icon: '/icons/icon-menu-securite.svg',
    //url: '/app/components',
    title: 'Sécurité',
    badgeIcon: 'my-badge br2 dot bg-color-notif',
    id: 'menu-securite',
    children: [
      { url: '/app/admins/list', id: 'menu-admins-list', title: 'Administrateurs', badgeIcon: 'my-badge br3 dot bg-color-warning', permissions: ['admins.read'] },
      { url: '/app/roles/list', id: 'menu-roles-list', title: 'Rôles', badgeIcon: 'my-badge br3 dot bg-color-danger', permissions: ['roles.read'] },
      { url: '/app/permissions/list', id: 'menu-permissions-list', title: 'Permissions', badgeIcon: 'my-badge br3 dot bg-color-danger', permissions: ['permissions.read'] },
    ]
  },
  {
    icon: '/icons/icon-menu-parametre.svg',
    //url: '/app/components',
    title: 'Paramètres',
    badgeIcon: 'my-badge br2 dot bg-color-notif',
    children: [
      { url: '#', title: 'Paramètres', badgeIcon: 'my-badge br3 dot bg-color-danger' },
    ]
  },
];

const appSidebarOpened = ref(true);
function toggleAppSidebar() { 
  appSidebarOpened.value = !appSidebarOpened.value; 
  emit("app-sidebar-toggled", appSidebarOpened.value);
}
function onMenuClick(menuId: string) { 
  if (activeMenu.value === menuId) {
    activeMenu.value = ''; // Désélectionner si déjà actif
    return;
  }
  activeMenu.value = menuId; 
}

</script>

<template>
    <aside class="sidebar" :class="{'close': !appSidebarOpened }"><!-- close -->
        <div class="sidebar-icon" @click="toggleAppSidebar()">
            <div class="barr1"></div>
            <div class="barr2"></div>
            <div class="barr3"></div>
        </div>

        <div class="clear-both"></div>

        <div class="logo-set">
            <img src="/images/logo.svg" class="logo">
        </div>

        <div class="user-set">
            <div class="user-img-set position-relative box-animate rounded">
                <img src="/assets/users/600w/user11.jpg" class="user-img position-relative">
            </div>
            <p class="user-info">
                <span>Juliette</span><br>
                Super Admin
            </p>
        </div>
        <div class="clear-both h-5"></div>

        <!--Menu sous-module-->
        <ul class="sidebar-menu-set">
          <template v-for="(menu, index) in appMenus" :key="'menu_' + index">
            <!--Components-->
            <div class="sidebar-menu-animate" :class="{'active': activeMenu == 'menu_' + index}">
                <router-link :to="menu.url ?? '#'">
                  <li class="sidebar-menu" :class="{'active': activeMenu == 'menu_' + index}" :id="menu.id ?? ''" @click="onMenuClick('menu_' + index)">
                      <img :src="menu.icon" class="sidebar-menu-icon" alt="" />
                      <span>{{ menu.title }}</span>
                      <!-- Badge dynamique pour les messages non lus -->
                      <template v-if="menu.showUnreadBadge && unreadCount > 0">
                        <div class="my-badge br2 bg-color-danger notification-badge">
                          {{ unreadCount > 99 ? '99+' : unreadCount }}
                        </div>
                      </template>
                      <template v-else>
                        <div class="my-badge br2 dot bg-color-notif"></div>
                      </template>
                  </li>
                </router-link>
            </div>
            <template v-if="!!menu.children && menu.children.length > 0">
              <ul class="sidebar-submenu" :class="{'active': activeMenu == 'menu_' + index}">
                <router-link :to="submenu.url" v-for="(submenu, subindex) in menu.children" :key="'submenu_' + subindex">
                  <li class="sidebar-submenu-item" v-hasPermissions="submenu.permissions ?? []" :id="submenu.id ?? ''">
                    {{ submenu.title }} 
                    <!-- Badge dynamique pour Service client -->
                    <template v-if="submenu.showUnreadBadge && unreadCount > 0">
                      <div class="my-badge br3 bg-color-danger notification-badge">
                        {{ unreadCount > 99 ? '99+' : unreadCount }}
                      </div>
                    </template>
                    <template v-else-if="submenu.badgeIcon">
                      <div :class="submenu.badgeIcon"></div>
                    </template>
                  </li>
                </router-link>
              </ul>
            </template>
            <!--End components-->
          </template>
          <div class="h-20"></div>
        </ul>
        
        <!-- <div class="h-100"></div> -->
        <!-- <div class="sidebar-bottom">
            <div class="rounded-30 px-5 py-5" style="background-color: rgb(var(--color-black-rgb), 0.96);">
                Test
            </div>
        </div> -->
    </aside>
</template>
